import { Badge, Box, IconButton, useTheme } from "@mui/material";
import { useContext, useEffect, useState } from "react";
import { ColorModeContext, tokens } from "../../theme";
import LightModeOutlinedIcon from "@mui/icons-material/LightModeOutlined";
import DarkModeOutlinedIcon from "@mui/icons-material/DarkModeOutlined";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import PersonOutlinedIcon from "@mui/icons-material/PersonOutlined";
import MailIcon from "@mui/icons-material/Mail";
import { Notifications } from "@mui/icons-material";
import AccountsMenu from "./AccountsMenu";
import NewRequests from "./NewRequests";
const Topbar = ({
  userNotification,
  notificationCount,
  setRefreshDashboard,
  onLogout,
  user,
}) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const colorMode = useContext(ColorModeContext);

  const [anchorEl, setAnchorEl] = useState(null);
  const [anchorE2, setAnchorE2] = useState(null);
  const open = Boolean(anchorEl);
  const openReq = Boolean(anchorE2);

  const [currentUser, setCurrentUser] = useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleClickReq = (event) => {
    setAnchorE2(event.currentTarget);
  };
  const handleCloseReq = () => {
    setAnchorE2(null);
  };

  return (
    <Box display="flex" justifyContent="flex-end" p={0.5}>
      {/* SEARCH BAR */}

      {/* ICONS */}
      <Box display="flex">
        <IconButton onClick={colorMode.toggleColorMode}>
          {theme.palette.mode === "dark" ? (
            <DarkModeOutlinedIcon />
          ) : (
            <LightModeOutlinedIcon />
          )}
        </IconButton>
        <IconButton
          onClick={handleClick}
          size="small"
          aria-controls={open ? "account-menu" : undefined}
          aria-haspopup="true"
          aria-expanded={open ? "true" : undefined}
        >
          <PersonOutlinedIcon />
        </IconButton>
      </Box>

      <NewRequests
        userNotification={userNotification}
        anchorEl={anchorE2}
        handleClose={handleCloseReq}
        open={openReq}
        setRefreshDashboard={setRefreshDashboard}
      />

      <AccountsMenu
        anchorEl={anchorEl}
        handleClose={handleClose}
        open={open}
        handleLogout={onLogout}
      />
    </Box>
  );
};

export default Topbar;
